
	import { Request } from '@/api/request';
	import { ElMessage } from 'element-plus'
	import {
		defineComponent,
		ref,
		reactive,
		inject,
		provide,
		onMounted,
		watch
	} from "vue";
	import { useRoute, useRouter } from 'vue-router'
	
	export default defineComponent({
		name: "operateCoupon_info",
		setup() {
			const Router = useRouter();
			const setTitle: any = inject("setTitle");
			setTitle(["优惠卷管理", '详情']);
			let form_load = ref(true),
				form = ref({
					title: '',
					start_time_text: '',
					end_time_text: '',
					type: '',
					full_price: '',
					reduce_price: '',
					is_use: ''
				})
				
			onMounted(() => {
				Request.axiosInstance({
					url: 'adminapi/Coupon/editInfo',
					data: {coupon_id: useRoute().query.id}
				}).then((res: any) => {
					
					form.value = res?.content?.list || form.value
					form_load.value = false
					console.log(form)
				})
			
			})
		
			return {
				form,
				form_load,
				Router
			
			};
		
		},
	});
